import React, {
  useContext,
  useEffect,
  useReducer,
  useState,
} from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import Collapse from "react-bootstrap/Collapse";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import { ThemeContext } from "../../../context/ThemeContext";
import { useDispatch, useSelector } from "react-redux";
import { setLogin } from "../../redux/reducer";
import { FaUserGraduate } from "react-icons/fa";
import { MdAdminPanelSettings } from "react-icons/md";
import { FaListCheck } from "react-icons/fa6";
import { useAccount } from 'wagmi';
import { getOwnerAddress } from "../../../services/getWeb3";
import { IoNotificationsOutline } from "react-icons/io5";
import { PiHandDepositFill } from "react-icons/pi";
import { HiOutlineBellAlert } from "react-icons/hi2";

const reducer = (prev, next) => ({ ...prev, ...next });
const initialState = {
  active: "",
  activeSubmenu: "",
};

const SideBar = () => {
  const [adminAddress, setAdminAddress] = useState(null);
  const { address } = useAccount();
  const { iconHover, sidebarposition, headerposition, sidebarLayout } = useContext(ThemeContext);
  const [state, setState] = useReducer(reducer, initialState);
  const [hideOnScroll, setHideOnScroll] = useState(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const login = useSelector((state) => state.login);
  let path = window.location.pathname.split("/").pop();

  useEffect(() => {
    const fetchOwner = async () => {
      const owner = await getOwnerAddress();
      setAdminAddress(owner?.toLowerCase());
    };
    fetchOwner();
  }, []);

  useScrollPosition(
    ({ prevPos, currPos }) => {
      const isShow = currPos.y > prevPos.y;
      if (isShow !== hideOnScroll) setHideOnScroll(isShow);
    },
    [hideOnScroll]
  );

  const handleMenuActive = (title) => {
    setState({ active: state.active === title ? "" : title });
  };

  const handleSubmenuActive = (title) => {
    setState({ activeSubmenu: state.activeSubmenu === title ? "" : title });
  };

  const Logout = () => {
    localStorage.removeItem("adminToken");
    dispatch(setLogin(false));
  };

  const baseMenuList = [
    {
      title: "Dashboard",
      classsChange: "mm-collapse",
      iconStyle: <i className="material-icons">grid_view</i>,
      to: "/dashboard",
    },
    {
      title: "User List",
      iconStyle: <FaUserGraduate className="fs-3" />,
      content: [
        { title: "All User", to: "/userList" },
        { title: "Active User", to: "/active-user" },
        { title: "Inactive User", to: "/inactive-user" },
      ],
    },
    // {
    //   title: "Upload Updates",
    //   to: "/UploadImage",
    //   iconStyle: <FiUpload className="fs-3" />
    // },
    // {
    //   title: "Upload Banner",
    //   to: "/UploadBanner",
    //   iconStyle: <FiUpload className="fs-3" />
    // },
    {
      title: "Deposit",
      to: "/level-upgrade",
      iconStyle: <PiHandDepositFill className="fs-3" />
    },
    {
      title: "Income-Report",
      to: "/income-report",
      iconStyle: <FaListCheck className="fs-3" />
    },
    // {
    //   title: "Support",
    //   iconStyle: <SlSupport className="fs-3" />,
    //   to: "/support-chats",
    // },

{
  title: "Notification System",
  iconStyle: <HiOutlineBellAlert className="fs-3" />,
  to: "/notification",
},
    {
      title: "Logout",
      iconStyle: <i className="material-icons">logout</i>,
      to: "/login",
    },
  ];

  // Inject "Admin Change" only if the current address matches the owner
  if (address?.toLowerCase() === adminAddress) {
    baseMenuList.splice(2, 0, {
      title: "Admin Change",
      to: "/ReawardWalletchange",
      iconStyle: <MdAdminPanelSettings className="fs-3" />
    });
  }

  return (
    <div
      className={`deznav  border-right ${iconHover} ${
        sidebarposition.value === "fixed" &&
        sidebarLayout.value === "horizontal" &&
        headerposition.value === "static"
          ? hideOnScroll > 120
            ? "fixed"
            : ""
          : ""
      }`}
    >
      <PerfectScrollbar className="deznav-scroll">
        <ul className="metismenu" id="menu">
          {baseMenuList.map((data, index) => {
            let menuClass = data.classsChange;
            if (menuClass === "menu-title") {
              return <li className={menuClass} key={index}>{data.title}</li>;
            } else {
              return (
                <li key={index} className={`${state.active === data.title ? "mm-active" : ""}`}>
                  {data.content ? (
                    <Link to="#" className="has-arrow" onClick={() => handleMenuActive(data.title)}>
                      {data.iconStyle}
                      <span className="nav-text">{data.title}</span>
                    </Link>
                  ) : (
                    <NavLink to={data.to} onClick={() => { if (data.title === "Logout") Logout(); }}>
                      {data.iconStyle}
                      <span className="nav-text">{data.title}</span>
                    </NavLink>
                  )}
                  <Collapse in={state.active === data.title}>
                    <ul className={`${menuClass === "mm-collapse" ? "mm-show" : ""}`}>
                      {data.content?.map((subItem, subIndex) => (
                        <li key={subIndex} className={`${state.activeSubmenu === subItem.title ? "mm-active" : ""}`}>
                          <Link to={subItem.to}>{subItem.title}</Link>
                        </li>
                      ))}
                    </ul>
                  </Collapse>
                </li>
              );
            }
          })}
        </ul>
      </PerfectScrollbar>
    </div>
  );
};

export default SideBar;
